let prefix = 'jwt-'


export function saveAuthToken(companyId, token) {    
    if(!companyId){
        return null
    }     
    localStorage.setItem(prefix + companyId, token)
}

export function getAuthToken(companyId) {
    if(!companyId){
        return null
    }
    let jwt = localStorage.getItem(prefix + companyId)
    return jwt || null
}

export function logout(companyId){
    if(companyId){
        localStorage.removeItem(prefix + companyId)
    }
}

